<template>
  <transition name="cancel-upload-task-dialog" appear>
    <div
      v-if="value"
      class="cancel-upload-task-dialog__overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cancel-upload-task-title"
      data-testid="cancel-upload-task-dialog"
      @mousedown.self="onGoBack"
      @keydown.esc="onGoBack"
    >
      <div class="cancel-upload-task-dialog__card">
        <div class="cancel-upload-task-dialog__featured-icon" aria-hidden="true">
          <Icon name="trash_03" class="cancel-upload-task-dialog__trash-icon" />
        </div>
        <h2 id="cancel-upload-task-title" class="cancel-upload-task-dialog__title">
          Cancel this task?
        </h2>
        <p class="cancel-upload-task-dialog__body">
          This will cancel the pending video-upload task for the assigned employee and revert this
          checkpoint to inspector-only. The checkpoint itself is kept. This can't be undone.
        </p>
        <div class="cancel-upload-task-dialog__footer">
          <StandardButton
            type="magenta"
            variant="secondary"
            size="normal"
            label="Go Back"
            :disabled="loading"
            @click="onGoBack"
          />
          <StandardButton
            type="red"
            variant="primary"
            size="normal"
            label="Cancel Task"
            :disabled="loading"
            :loaderLeft="loading"
            @click="onConfirm"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import Icon from "@components/icons/Icon.vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["input", "confirm"]);

function onGoBack() {
  if (props.loading) return;
  emit("input", false);
}

function onConfirm() {
  if (props.loading) return;
  emit("confirm");
}
</script>

<style scoped>
.cancel-upload-task-dialog__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(16, 24, 40, 0.5);
}

.cancel-upload-task-dialog__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  max-width: 400px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  box-shadow: 0 8px 24px -4px rgba(15, 23, 41, 0.15);
}

.cancel-upload-task-dialog__featured-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fbbab8;
  background: #fee4e3;
  box-sizing: border-box;
}

.cancel-upload-task-dialog__trash-icon {
  color: #d92d20;
  width: 24px;
  height: 24px;
}

.cancel-upload-task-dialog__title {
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: normal;
  color: #212529;
}

.cancel-upload-task-dialog__body {
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  color: #475367;
}

.cancel-upload-task-dialog__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.cancel-upload-task-dialog-enter-active,
.cancel-upload-task-dialog-leave-active {
  transition: opacity 0.15s ease;
}

.cancel-upload-task-dialog-enter,
.cancel-upload-task-dialog-leave-to {
  opacity: 0;
}
</style>
